import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _reduce from 'lodash/reduce';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Custom
import withPermissions from 'hocs/WithPermissions';
import AppIcon from 'components/icons/AppIcon';

const ItemsSelectField = ({
  labelId, value, items, withNullItem, errorText, hasPermission, onChange, ...otherProps
}) => {
  // Build final items
  const builtItems = _reduce(items, (result, item) => {
    if (!item.permission || hasPermission(item.permission)) {
      result.push({
        key: item.key,
        header: item.header,
        labelId: item.labelId,
        value: item.value,
        icon: item.icon && <AppIcon id={item.icon} color={item.color} defaultColor={!item.color} />,
      });
    }
    return result;
  }, []);

  const handleChange = (val) => {
    if (val !== '_ignore') {
      onChange(val);
    }
  };

  return (
    <Select
      label={labelId && <LocalizedMessage id={labelId} />}
      value={value}
      items={builtItems}
      withNullItem={withNullItem}
      errorText={errorText}
      onChange={handleChange}
      {...otherProps}
    />
  );
};

ItemsSelectField.propTypes = {
  labelId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
      labelId: PropTypes.string.isRequired,
      icon: PropTypes.string,
      charIcon: PropTypes.string,
      color: PropTypes.string,
    }),
  ).isRequired,
  withNullItem: PropTypes.bool,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  hasPermission: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

ItemsSelectField.defaultProps = {
  labelId: null,
  value: null,
  withNullItem: false,
  errorText: null,
};

module.exports = withPermissions(ItemsSelectField);



// WEBPACK FOOTER //
// ./components/inputFields/ItemsSelectField.js